import alertMixin from 'shared/mixins/alertMixin';

export default {
  mixins: [alertMixin],
  props: {
    assistent: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isSaving() {
      return this.$store.getters['assistent/getUIFlags'].updatingItem;
    },
  },
  methods: {
    async saveAssistent(fields) {
      const payload =
        fields instanceof FormData
          ? fields
          : { id: this.assistent.id, assistent: fields };

      try {
        await this.$store.dispatch('assistent/update', payload);
        this.showAlert(
          this.$t('INTEGRATION_SETTINGS.ASSISTENT.EDIT.API.SUCCESS_MESSAGE')
        );
      } catch (error) {
        this.showAlert(
          this.$t('INTEGRATION_SETTINGS.ASSISTENT.EDIT.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
